import { createQuery } from 'react-query-kit';

import { STALE_TIME } from '@blockworks/platform/api';
import { coinGeckoApi } from '@blockworks/platform/api/coingecko';

import { internalPriceChartApi } from '@/api/price-chart/internal';

import { selectPriceList } from './price-chart.selectors';

export const usePriceChart = createQuery({
    queryKey: [coinGeckoApi.get.priceChart.cachePrefix],
    fetcher: internalPriceChartApi.get.priceChart,
    staleTime: STALE_TIME.$1Hour,
});

const priceChartQueries = {
    getPriceChart: {
        use: usePriceChart,
        select: { priceList: selectPriceList },
    },
};

export { priceChartQueries };
